var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",attrs:{"title":"Lookup Results","height":"390px"}},[_c('model-list',{attrs:{"models":_vm.remapped},on:{"click":_vm.clicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }